<template>
    <div class="column right has-text-centered">
        <h1 class="title is-4">Registrarse</h1>
        <!-- <p class="description">Complete los campos para registrarse</p> -->
        <form @submit.prevent="submit">
            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="number" placeholder="Matrícula"
                        name="matricula" id="matricula" v-model="form.matricula">
                </div>
            </div>
            
            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="text" placeholder="Documento"
                        name="dni" id="dni" v-model="form.dni">
                </div>
            </div>

            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="email" placeholder="Email"
                        name="email" id="email" v-model="form.email">
                </div>
            </div>

            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="password" placeholder="Contraseña"
                        name="password" id="password" v-model="form.password">
                </div>
            </div>
            
            <div class="field">
                <div class="control">
                    <input class="input is-medium" type="password" placeholder="Repetir Contraseña"
                        name="password_confirmation" id="password_confirmation" v-model="form.password_confirmation">
                </div>
            </div>

            <button class="button is-block is-primary is-fullwidth is-medium">Registrar</button>
            <br />
            <small class="has-text-danger"><em>{{errors}}</em></small>
        </form>
    </div>                    
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'register',
    created(){
        this.clearAuthErrors()
    },
    components: {
        //
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors'
        }),
    },    
    data(){
        return{
            form:{
                matricula: '',
                dni: '',
                email: '',
                password: '',
                password_confirmation: ''
            }
        }
    },
    methods:{
        ...mapActions({
            signUp: 'auth/signUp',
            clearAuthErrors: 'auth/clearAuthErrors',
        }),

        submit(){
            this.signUp(this.form)
            .then( (response) => {
                console.log(response);
            }).catch(() => {
                console.log("Login Failed!");
            })
        }
    }
}
</script>

<style>

</style>